<template>
  <div class="pg2" v-show="isShow.isPTShow">
    <div class="wp">
      <img :src="fnSrc" class="mySrc" alt="">
      <p class="notice shine">长按保存海报</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageTwo',
  props: {
    isShow: Object,
    fnSrc: String
  }
}
</script>

<style lang="less" scoped>
.bg(@url) {
  background-image: url(@url);
  background-size: cover;
  background-repeat: no-repeat;
}
.pg2 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  .bg('../paegKV/img/kv-bg.jpg');
}
.wp {
  width: 80%;
}
.mySrc {
  width: 100%;
  height: auto;
}
.notice {
  margin-top: 0.5rem;
  text-align: center;
  color: white;
  letter-spacing: 2px;
  font-size: 1.125rem /* 18/16 */;
  text-shadow: 0 0 10px rgba(50, 50, 50, 0.5);
}
.shine {
  animation: shine 2s ease-in-out infinite;
}
@keyframes shine {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}
</style>